<div class="col-lg-8">
    <br>
    <br>
    <div class="jumbotron">
        <form>
            <div class="form-row">
                <div class="col col-md-4">
                    <label for="user">USUARIO</label>
                    <input [(ngModel)]="user" name="user" type="text" class="form-control">
                </div>
                <div class="col col-md-4">
                    <label class="col" for="pass">Contraseña</label>
                    <input [(ngModel)]="pass" name="pass" type="password" class="form-control">
                </div>
            </div>
        </form>
        <br>
        <button (click)="login()" routerLinkActive="router-link-active" type="button" class="btn btn-primary btn-lg">
          Iniciar Sesión
        </button>
    </div>
</div>



<!-- Boton trigger modal completa formulario -->
<button hidden id="abremodal" type="button" class="btn btn-success" data-toggle="modal" data-target="#modalSeguridad">
    modal 
</button>
<button hidden type="button" class="btn btn-danger" (click)="lanzaModal()">
    modal 
</button>




<!-- Modal SEGURIDAD PRIMER INGRESO FORMULARIO -->
<div data-backdrop="static" data-keyboard="false" style="margin-top: 60px" class="modal fade" id="modalSeguridad" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalSeguridad" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">¡Bienvenido a sideu!</h5>
                <button hidden type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div *ngIf="error==true;" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Obligatorio Completar!</strong> Es necesario cambiar la contraseña y completar el formulario.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <P>
                    Al ser la primera vez que ingresa, le pediremos que complete las preguntas de seguridad, y cambie la contraseña otorgada por el departamento de sistemas..
                </P>
                <div id="carguita">
                    <label for="pre1">Seleccione pregunta de seguridad numero 1</label>
                    <select [(ngModel)]="pregunta1" name="pregunta1" id="inputState" class="form-control">
                      <option>¿Cual es el nombre de su mejor amigo de la infancia?</option>
                      <option>¿Cual fue la marca de su primer auto?</option>
                      <option>¿Cual es el nombre de su primer mascota?</option>
                      <option>¿Cual es el nombre de su profesor favorito?</option>
                      <option>elija esta opcion si quiere poner una palabra clave que no responda a ninguna pregunta de las anteriores</option>                      
                    </select>
                    <label for="pre1">Ingrese la respuesta a su pregunta..</label>
                    <input [(ngModel)]="respuesta1" name="respuesta1" type="text" class="form-control">
                    <hr>
                    <label for="pre1">Seleccione pregunta de seguridad numero 2</label>
                    <select [(ngModel)]="pregunta2" name="pregunta2" id="inputStatea" class="form-control">
                      <option>¿Cual es el nombre de su mejor amigo de la infancia?</option>
                      <option>¿Cual fue la marca de su primer auto?</option>
                      <option>¿Cual es el nombre de su primer mascota?</option>
                      <option>¿Cual es el nombre de su profesor favorito?</option>
                      <option>elija esta opcion si quiere poner una palabra clave que no responda a ninguna pregunta de las anteriores</option>                      
                    </select>
                    <label for="pre2">Ingrese la respuesta a su pregunta..</label>
                    <input [(ngModel)]="respuesta2" name="respuesta2" type="text" class="form-control">
                    <hr>
                    <label for="pas">Ingrese su nueva Contraseña:</label>
                    <input [(ngModel)]="passwd" name="passwd" type="text" class="form-control">

                </div>
            </div>
            <div class="modal-footer">
                <button (click)="blanqueaIngresos()" type="button" class="btn btn-secondary">CANCELAR</button>
                <button data-dismiss="modal" (click)="actualizarUser()" type="button" class="btn btn-success">Guardar Cambios!</button>
            </div>
        </div>
    </div>
</div>